var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{staticClass:"mb-5"},[_c('template',{slot:"body"},[_c('h6',{staticClass:"heading-small text-muted montserrat"},[_vm._v("Images")]),_c('lightbox',{attrs:{"css":"h-200 h-lg-250","cells":4,"items":_vm.items}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }